/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
/// <reference path="../../_ext/Bases/DialogBase.ts" />
/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Inventory {

    import fld = SKUStockItemRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SKUStockItemEditor extends _Ext.ItemGridEditor<SKUStockItemRow> {
        


        protected getColumnsKey() { return "Inventory.SKUStockItem"; }
        protected getDialogType() { return SKUStockItemDialog; }
        protected getLocalTextPrefix() { return SKUStockItemRow.localTextPrefix; }
        protected form: SKUStockItemForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        public currentrow: SKUStockItemRow;
        public _row: number;
        // #endregion

        static Items: any[];
        static LineNo: number[];


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e)); 
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
             
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            //columns.push(
            //    {
            //        field: 'Generate SKU',
            //        name: 'SKU',
            //        format: ctx => '<a class="inline-action add-button gen-sku" href="#"><span></span>Genrate SKU</a>',
            //        width: 90,
            //        minWidth: 90,
            //        maxWidth: 90
            //    });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

             

            var item = this.itemAt(row);
            var target = $(e.target);
            this.currentrow = this.itemAt(row);
            this._row = row;
            (this.parentDialog as SKUGenerationDialog).form.Pieces.value = item.Pieces;
            (this.parentDialog as SKUGenerationDialog).form.SKUSelected.value = item.SKU;
            (this.parentDialog as SKUGenerationDialog).form.ProductIdSelected.value = item.ProductId.toString();
            (this.parentDialog as SKUGenerationDialog).form.AttributeIdSelected.value = item.AttributeId.toString();
            (this.parentDialog as SKUGenerationDialog).form.LineNoSelected.value = item.Line_No.toString();
            (this.parentDialog as SKUGenerationDialog).setPrintingGrid(item.ItemsDetails);
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);


                    });
                    this.view.refresh();
                }

                if (target.hasClass('gen-sku')) {
                    //set items on dialog open 
                    let recordId = item[this.getIdProperty()];//get id
                    this.editItem(recordId);//set as edit
                }
                this.view.refresh();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    //item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    //item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    //item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    //item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    //item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    //item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    //item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    //item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    //item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    //if (item.WstPer != null) {
                    //    item.WstWt = item.NetWeight * (item.WstPer / 100);
                    //}
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            //// *** Calculate Wastage ***
            //if (field === fld.WstPer && value >= 0) {
            //    item.WstWt = item.NetWeight * (value / 100);
            //    item[field] = value;
            //}

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Stock.StockSKUGrid;

            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var orddetails = [];  
                        // #region Items to Grid
                       
                        selectedItems2.forEach(function (Item: Stock.StockItemRow) {
                            
                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AtbID ****
                            

                            // #endregion

                            var ItemDetails = [];

                            var purchase: SKUStockItemRow = {
                                ProductId: Item.ProductId,
                                AttributeId: Item.AttributeId,
                                Line_No: Item.Line_No,
                                PartyId: Item.PartyId,
                                SKU: Item.SKU,
                                DepartmentId: Item.DepartmentId,
                                ProductCode: Item.ProductCode,
                                ProductName: Item.ProductName,
                                ItemTypeId: Item.ItemTypeId,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                BrandId: Item.BrandId,
                                SuperTypeId: Item.SuperTypeId,
                                CollectionId: Item.CollectionId,
                                UnitRate: Item.Rate,
                                Pieces: Item.Pieces,
                                Weight: Item.Weight,
                                OtherPieces: Item.OtherPieces,
                                OtherWeight: Item.OtherWeight,
                                StonePieces: Item.StonePieces,
                                Stoneweight: Item.StoneWeight,
                                NetWeight: Item.NetWeight,
                                NetAmount: Item.Rate,
                                GrossAmount: Item.CalcOnId == 3 ? Item.Rate * Item.Pieces : Item.Rate * Item.Weight,
                                DiamondPieces: Item.DiamondPieces,
                                DiamondWeight: Item.DiamondWeight,
                                CalcOnId: Item.CalcOnId,
                                CompanyId: Item.CompanyId,
                                CostMethodId: Item.CalcOnId,
                                TransId: Item.TransId,
                                VoucherTypeId: 51,
                                RefVoucherId: Item.VoucherTypeId,
                                ItemsDetails: ItemDetails, 
                                HasBom: Item.HasBom,
                                BagNo: Item.BagNo,
                                LotNo: Item.LotNo,
                                CertificateNo: Item.CertificateNo,
                                Lab: Item.Lab,
                                RefTransId: Item.TransId,
                                RefTransItemId: Item.TransItemId,
                                StockId: Item.StockId,
                                DesignId:Item.DesignId
                                
                            };
                            orddetails.push(purchase);

                        });
                         
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = orderDetail;
                            this.view.addItem(orderDetail);
                        }

                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }

        // #endregion
        //Set Data when the values changed from Master Dialog 
        public setData(entity: any, AtbId: number, count: number, row: number, markup: number = 1) {
            var stockitem = this.itemAt(row);

            var x: Stock.StockItemRow = entity;
            var AllowSKUSplitting = q.ToBool(TabAurous.GetConfigValue(1009));  
            if (AllowSKUSplitting && count > entity.Pieces) {
                var netwtperitem = entity.NetWeight / count;
                var weightperitem = entity.Weight / count;
            }
            else {
                var netwtperitem = entity.NetWeight / entity.Pieces;
                var weightperitem = entity.Weight / entity.Pieces;
            }



            var StockIds = [];
            StockIds.push(entity.StockId);
            var BOM: Stock.StockItemBOMRow[];
            Stock.StockItemBOMService.GetStockBOM({ StockIds: StockIds }, response => BOM = response.Entities, { async: false });

            for (var i = 0; i < count; i++) {
                var SKU = FormatHelper.GetFormats("SKU");

                var bomitems = [];
                for (var j = 0; j < BOM.length; j++) {

                    var Amount = 0
                    if (BOM[j].CalcOnId != 3) {
                        var wt = count > entity.Pieces ? BOM[j].Weight / count : BOM[j].Weight / entity.Pieces
                        Amount = (wt * BOM[j].BomRate) * markup;
                    }
                    else {
                        var pcs = count > entity.Pieces ? BOM[j].Pieces / count : BOM[j].Pieces / entity.Pieces
                        Amount = (pcs * BOM[j].BomRate) * markup;
                    }


                    var bomitem: SKUItemBOMRow = {
                        BomAmount: Amount,
                        BOMAttributeId: BOM[j].BOMAttributeId,
                        BomRate: BOM[j].BomRate * markup,
                        CalcOnId: BOM[j].CalcOnId,
                        CertificateNo: BOM[j].CertificateNo,
                        Lab: BOM[j].Lab,
                        Pieces: count > entity.Pieces ? BOM[j].Pieces / count : BOM[j].Pieces / entity.Pieces,
                        BOMProductId: BOM[j].BOMProductId,
                        ProductCode: BOM[j].ProductCode,
                        ProductId: BOM[j].ProductId,
                        ItemTypeId: BOM[j].ItemTypeId,
                        Remarks: BOM[j].Remarks,
                        SettingId: BOM[j].SettingId,
                        //StoneStatusId: BOM[j].StoneStatusId,
                        Weight: count > entity.Pieces ? BOM[j].Weight / count : BOM[j].Weight / entity.Pieces,
                        RefStockBomId: BOM[j].StockBomId,
                        Purity: BOM[j].Purity,
                        PureWeight: count > entity.Pieces ? BOM[j].PureWeight / count : BOM[j].PureWeight / entity.Pieces
                    }
                    bomitems.push(bomitem);

                }

                var Rate = 0;
                var Amount = 0;
                if (bomitems.length > 0) {
                    bomitems.forEach(function (BOMItem) {
                        Rate += BOMItem.BomAmount;
                    })
                }
                else {
                    Rate = entity.UnitRate;
                }

                var item: SKUItemsRow = {
                    ProductId: x.ProductId,
                    ProductCode: x.ProductCode,
                    ProductName: x.ProductName,
                    AttributeId: AtbId,
                    CalcOnId: x.CalcOnId,
                    CompanyId: x.CompanyId,
                    DepartmentId: x.DepartmentId,
                    SKU: SKU,
                    Pieces: 1,
                    Weight: weightperitem,
                    NetWeight: netwtperitem,
                    Line_No: x.Line_No,
                    ItemTypeId: x.ItemTypeId,
                    ProductTypeId: x.ProductTypeId,
                    CategoryId: x.CategoryId,
                    SubCategoryId: x.SubCategoryId,
                    BrandId: x.BrandId == undefined ? 0 : x.BrandId,
                    SuperTypeId: x.SuperTypeId == undefined ? 0 : x.SuperTypeId,
                    CollectionId: x.CollectionId == undefined ? 0 : x.CollectionId,
                    KaratId: x.KaratId == undefined ? 0 : x.KaratId,
                    DiamondPieces: count > entity.Pieces ? x.DiamondPieces / count : x.DiamondPieces / entity.Pieces,
                    DiamondAmount: count > entity.Pieces ? x.DiamondAmount / count : x.DiamondAmount / entity.Pieces,
                    DiamondWeight: count > entity.Pieces ? x.DiamondWeight / count : x.DiamondWeight / entity.Pieces,
                    OtherAmount: count > entity.Pieces ? x.OtherAmount / count : x.OtherAmount / entity.Pieces,
                    OtherPieces: count > entity.Pieces ? x.OtherPieces / count : x.OtherPieces / entity.Pieces,
                    OtherWeight: count > entity.Pieces ? x.OtherWeight / count : x.OtherWeight / entity.Pieces,
                    StoneAmount: count > entity.Pieces ? x.StoneAmount / count : x.StoneAmount / entity.Pieces,
                    StonePieces: count > entity.Pieces ? x.StonePieces / count : x.StonePieces / entity.Pieces,
                    StoneWeight: count > entity.Pieces ? x.StoneWeight / count : x.StoneWeight / entity.Pieces,
                    BagNo: x.BagNo,
                    CertificateNo: x.CertificateNo,
                    HSN: x.HSN,
                    RefTransId: entity.TransId,
                    RefVoucherId: entity.VoucherTypeId,
                    BOMDetails: bomitems,
                    PartyId: entity.PartyId == null ? 0 : x.PartyId,
                    UnitRate: Rate,
                    NetAmount: entity.CalcOnId != 3 ? Rate * weightperitem : Rate * 1,
                    GrossAmount: entity.CalcOnId != 3 ? Rate * weightperitem : Rate * 1,
                    HasBom: x.HasBom,
                    Lab: x.Lab,
                    LotNo: x.LotNo,
                    Purity: x.Purity,
                    PureWeight: weightperitem * x.Purity,
                    MetalId: x.MetalId == undefined ? 0 : x.MetalId,
                    MetalColorId: x.MetalColorId == undefined ? 0 : x.MetalColorId,
                    QualityId: x.QualityId,
                    
                };
                //item.TransItemId = this.nextId++;
                item[this.getIdProperty()] = "`" + this.nextId++;
                //this.view.addItem(item);

                stockitem.ItemsDetails.push(item);
            }
            var id = this.id(stockitem);
            this.view.updateItem(id, stockitem)
            return stockitem.ItemsDetails;
        }

        //Set Data when values changed in the Print Editor of Master Dialog
        setNewData(lineno: any, productid: any, attributeid: any, sku: string, newitems: SKUItemsRow[]) {
            var olditem = this.view.getItems().filter(x => x.ProductId == productid && x.AttributeId == attributeid && x.Line_No == lineno && x.SKU == sku)[0];
            var row = this.id(olditem);
            if (olditem != undefined) {
                olditem.ItemsDetails = newitems;
                this.view.updateItem(row, olditem)
            }
        }
    }
}